/// <reference path='../../../../typings/index.d.ts' />

module Meevo.Plugins.ClientIntakeForm {

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import AppAreaEnum = Meevo.Model.AppAreaEnum;
    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import IIntakeFormSettings = Meevo.Plugins.ClientIntake.IIntakeFormSettings;
    import ControlTypeEnum = Meevo.Model.ControlTypeEnum;
    import DocsAndFormsRenderService = Meevo.Plugins.DocsAndForms.DocsAndFormsRenderService;
    import DocsAndFormsCreationTypeEnum = Meevo.Plugins.DocsAndForms.DocsAndFormsCreationTypeEnum;
    import IDocsAndFormsModel = Meevo.Plugins.DocsAndForms.IDocsAndFormsModel;

    export class ClientIntakeFormService extends Meevo.Components.CommonClasses.CommonDataServiceBase {

        static factory(): Function {
            let instance = (dataService: Meevo.Components.BaseClasses.IDataService,
                            $q: angular.IQService,
                            appSettings: Meevo.Components.Common.IAppSettings,
                            identityService: Meevo.Components.Common.IIdentityService,
                            $http: angular.IHttpService,
                            $locale: ng.ILocaleService,
                            dafRenderService: DocsAndFormsRenderService) => {
                return new ClientIntakeFormService(
                    dataService,
                    $q,
                    appSettings,
                    identityService,
                    $http,
                    $locale,
                    dafRenderService
                );
            };

            instance.$inject = [
                'meevo.components.common.DataService',
                '$q',
                'meevo.AppSettings',
                'meevo.components.common.IdentityService',
                '$http',
                '$locale',
                'meevo.plugins.docsAndForms.DocsAndFormsRenderService',
            ];

            return instance;
        }

        constructor(protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected $q: angular.IQService,
                    protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected $http: angular.IHttpService,
                    protected $locale: ng.ILocaleService,
                    protected dafRenderService: DocsAndFormsRenderService) {
            super(appSettings, $http);
        }

        getFormBuilderByBizType(bizType: string | null): angular.IPromise<IDocsAndFormsModel> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.clientIntakeFormBuilder}/`, {
                params: {businessType_TId: bizType}
            })
                .then((response) => response.data);
        }

        public getUdfControls(): ng.IPromise<IUserDefinedControl[]> {
            return this.getUdfList()
                .then((res) => {
                    const udfIds = res
                        .filter((row) => row.controlTypeEnum !== ControlTypeEnum.ImageUpload && row.controlTypeEnum !== ControlTypeEnum.DocumentUpload)
                        .map((row) => row.control_TId);

                    return this.$q.all(udfIds.map((row) => this.getUdfControl(row)));
                });
        }

        public getUdfControl(id): ng.IPromise<any> {
            return this.dataService.getItem(`ClientIntakeForms/Control`, id);
        }

        public getIntakeFormSettings(): ng.IPromise<IIntakeFormSettings> {
            return this.dataService.getItem(`ClientIntakeForms/Settings `);
        }

        assignControlToFormProcess(controls: IUserDefinedControl[], form: IIntakeFormModel) {
            return this.dataService.add(`CustomData/Tab`, {
                tab: form,
                controls
            });
        }

        formExists(businessTypeId: string | null): ng.IPromise<boolean> {
            return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.clientIntakeForm}/Exists`, 'POST', {
                businessType_TId: businessTypeId
            }).then((res) => {
                return res.data.exists;
            });
        }

        createFormForBusinessType(businessTypeId: string | null, $scope: ng.IScope): ng.IPromise<IIntakeFormModel> {
            return this.$q.all([
                this.getFormBuilderByBizType(businessTypeId),
                this.dafRenderService.generateHTMLDefaultIntakeTemplate($scope)
            ]).then(([form, html]) => {
                form.templateHTML = html;
                form.formCreationTypeEnum = DocsAndFormsCreationTypeEnum.CustomHtmlUpload;
                form.objectState = ObjectStateEnum.Active;

                return this.intakeFormPost(form)
            });
        }

        intakeFormPost(form: IIntakeFormModel): ng.IPromise<IIntakeFormModel> {
            return this.dataService
                .customMethodData(
                    `${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.clientIntakeFormBuilder}/`,
                    'POST',
                    form
                ).then((res) => {
                    return res.data;
                });
        }

        getForm(businessTypeId: string | null, $scope: ng.IScope): ng.IPromise<IIntakeFormModel> {
            return this.formExists(businessTypeId)
                .then((exist) => {
                    if (exist) {
                        return this.getFormBuilderByBizType(businessTypeId);
                    }

                    // if not exists we create a new one with default template
                    if (this.identityService.current().isSingleLocation || this.identityService.userBusinessTypes.length === 1) {
                        // for single location and for tenant with one business type
                        return this.createFormForBusinessType(businessTypeId, $scope);
                    } else {
                        // for All Business Type
                        // User Story 36397: CiF: System default template should be available
                        return this.createFormForBusinessType(null, $scope);
                    }
                });
        }

        private getUdfList(): ng.IPromise<IUserDefinedControl[]> {
            return this.dataService.getListPaged(`ClientIntakeForms/Control`, {
                criteria: {
                    shortcut: null,
                    controlTypeEnum: null,
                    appAreaEnum: AppAreaEnum.Client,
                    objectStateEnums: [ObjectStateEnum.Active, ObjectStateEnum.Inactive]
                },
                itemsPerPage: 50000
            });
        }
    }

    angular.module('meevo.plugins.clientIntakeForm')
        .service('meevo.plugins.clientIntakeForm.ClientIntakeFormService', ClientIntakeFormService.factory());
}
